import {
    EDIT_HEALTH_PARTNER, DELETE_HEALTH_PARTNER, CREATE_HEALTH_PARTNER, CREATE_HEALTH_PARTNER_SUCCESS, UPDATE_HEALTH_PARTNER_SUCCESS,
    UPDATE_HEALTH_PARTNER, DELETE_HEALTH_PARTNER_SUCCESS, FETCH_ALL_HEALTH_PARTNER, FETCH_ALL_HEALTH_PARTNER_SUCCESS,SET_HEALTH_PARTNER
  } from 'constants/health_partners.constants'
import { startLoader } from 'actions/general.action';

export const setHealthPartner = (key, value) => {
    return {
      type : SET_HEALTH_PARTNER,
      key: key,
      value: value
    }
}

export const fetchHealthPartners = (page) => {
    return dispatch => {
      dispatch({
        type: FETCH_ALL_HEALTH_PARTNER,
        payload: page
      })
      dispatch(startLoader())
    }
  }
  
  export const fetchHealthPartnersSuccess = (data) => {
    return {
      type: FETCH_ALL_HEALTH_PARTNER_SUCCESS,
      payload: data
    };
  };
  
  export const deleteHealthPartner = (id) => {
    return {
      type: DELETE_HEALTH_PARTNER,
      payload: id
    };
  };
  
  export const editHealthPartner = (id) => {
    return {
      type: EDIT_HEALTH_PARTNER,
      payload: id
    };
  };
  
  export const createHealthPartner = (payload) => {
    console.log(payload)
    return {
      type: CREATE_HEALTH_PARTNER,
      payload: payload
    };
  };
  
  export const createHealthPartnerSuccess = (payload) => {
    return {
      type: CREATE_HEALTH_PARTNER_SUCCESS,
      payload: payload
    };
  };
  
  export const updateHealthPartnerSuccess = (data) => {
    return {
      type: UPDATE_HEALTH_PARTNER_SUCCESS,
      payload: data
    };
  };
  
  export const deleteHealthPartnerSuccess = (data) => {
    return {
      type: DELETE_HEALTH_PARTNER_SUCCESS,
      payload: data
    };
  };
  
  export const updateHealthPartner = (payload) => {
    return {
      type: UPDATE_HEALTH_PARTNER,
      payload: payload
    };
  }; 